import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';


export default {
  name: 'CmrContrPnlReadingsBasicInfo',
  components: {
  },
  props: {
    readingData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modifyConsumption: {
      type: Boolean,
      default: false
    },
    isCurrentReading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      date: null,
      dateFormat: this.$store.getters.getDateFormat,
    }
  },
  watch: {
    date: function (val) {
      this.readingData.date = moment(val).format();
    },
    "readingData.read": function (val) {
      this.$root.$emit('cmr_cur_reading_changed', val);
    }
  },
  computed: {
    dateDisplay: {
      set: function () {},
      get: function () {
        return moment(this.readingData.date).format(this.dateFormat);
      },
    },
    isCurrentOrPrevious: function () {
      return this.isCurrentReading == true ? 'current' : 'previous';
    },
    avrgConsDisplay: {
      set: function () {},
      get: function () {
        return this.readingData.avrgCons == 0 ? 0 : Number.parseFloat(this.readingData.avrgCons).toFixed(6);
      },
    },
  },
  mounted() {    
    this.date = new Date(this.readingData.date);
  },
  methods: {
    getIdWithPrefix(id) {
      return this.isCurrentOrPrevious + id;
    }
  }
}
